import React, { useCallback } from 'react';
import { styled } from '@compiled/react';
import OpenIcon from '@atlaskit/icon/glyph/open';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { LazySingleLineSmartLink } from '@atlassian/jira-issue-field-smart-link/src/ui/single-line-smart-link/async.tsx';

type Props = { value: string };

export const SmartLink = ({ value }: Props) => {
	const DefaultLink = useCallback(
		() => (
			<a href={value} target="_blank">
				<LinkText>{value}</LinkText>

				<LinkFollower data-component-selector="business-list.ui.list-view.url-cell.link-follower">
					<OpenIcon label={value} />
				</LinkFollower>
			</a>
		),
		[value],
	);

	if (value && expValEquals('jsw_perf_format-links-in-custom-fields', 'list-view', true)) {
		return (
			<Box xcss={smartLinkWrapperStyles}>
				<LazySingleLineSmartLink anchorTarget="_blank" url={value} fieldType="url" />
			</Box>
		);
	}

	return <DefaultLink />;
};

const smartLinkWrapperStyles = xcss({
	marginLeft: 'space.100',
	marginRight: 'space.100',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LinkFollower = styled.span({
	width: token('space.300', '24px'),
	background: token('color.background.neutral.subtle', '#fff'),
	display: 'none',
	alignItems: 'center',
	flexShrink: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const LinkText = styled.span({
	whiteSpace: 'nowrap',
	maxWidth: '100%',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
	flexShrink: 1,
});
